import {
  Avatar, Button, Card, CardContent, CardHeader, CircularProgress,
  Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem,
  ListItemSecondaryAction, ListItemText, Slide, Tooltip, Typography
} from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  contentBulten: {
    minHeight: 430,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function GenericBulten({ className, param }) {


  const classes = useStyles();
  const [GenericBultenData, setGenericBultenData] = useState([]);
  const SessionUser = getUser();
  const GenericBirimKodu = SessionUser.ServiceShopId;
  const GenericTeknisyenKodu = SessionUser.TechnicianId;
  const [Loading, setLoading] = useState(true);
  const [openBultenDialog, setopenBultenDialog] = useState(false);
  const [PdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (param === '') {
      setGenericBultenData([]);
      setLoading(false);
      return;
    }
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetBulten/' + GenericBirimKodu + '/' + GenericTeknisyenKodu + '/' + param)
        .then((response) => {
          if (mounted) {
            const Deger = response.data === "" ? [] : response.data;
            setGenericBultenData(Deger);
            setLoading(false);
          }
        }).catch(error => {
          setLoading(false);
        });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [GenericBirimKodu, GenericTeknisyenKodu, param]);

  const handleCloseBultenDialog = () => {
    setopenBultenDialog(false);
  };



  const GenericBultenAc = (logData) => {
    const dataBultenAc = {
      BIRIM_KODU: SessionUser.ServiceShopId,
      SICIL_NO: SessionUser.UserId,
      FilePtr: logData.FP,
    };
    const configGeneric = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/BulletinDetail', dataBultenAc, configGeneric)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setPdfUrl(fileURL);
        setopenBultenDialog(true);
      }).catch(error => {
        console.log(error);
      });
  };


  if (GenericBultenData.length === 0) {
    return <Card className={classes.root}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" color="primary">
            <WarningIcon />
          </Avatar>
        }
        title={param}
        subheader="İlgili bülten bulunamadı!..."
      />
    </Card>;
  }

  return (
    <Page>
      <Card className={clsx(classes.root, className)}>
        <Divider />
        <CardContent className={classes.contentBulten}>
          <div className={classes.inner}>
            {Loading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              :
              GenericBultenData.map(Genericlog => (
                <div key={Genericlog.BN}>
                  <List className={classes.root}>
                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={Genericlog.BT}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {Genericlog.A + ' '}

                              {Genericlog.GUN + ' ' + Genericlog.AY + ' ' + Genericlog.YIL}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction>
                        <Tooltip title="Bülten Göster">
                          <IconButton
                            color="primary"
                            edge="end"
                            onClick={() => GenericBultenAc(Genericlog)}
                            size="small">
                            <CloudDownloadIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                  </List>
                </div>
              ))}
          </div>
        </CardContent>
      </Card>
      <Dialog
        open={openBultenDialog}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={handleCloseBultenDialog}      >
        <DialogTitle>
          Bülten Detayı
        </DialogTitle>
        <DialogContent>
          <iframe
            width="100%"
            height="700"
            src={PdfUrl}></iframe>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBultenDialog} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

GenericBulten.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(GenericBulten);

